/** Leaf module — shared Tailwind tokens with no app imports (avoids CB ↔ IG cycles). */
export const collectionBuildBorderClassName = "border-[#737373]";

/** Report / slide carousel prev-next — shared by Collection Build and Image Generator. */
export const reportSlidePageButtonClassName = `box-border flex h-8 w-8 items-center justify-center rounded-lg border ${collectionBuildBorderClassName} bg-white text-sm text-secondary hover:bg-[#F6F3F0] disabled:cursor-not-allowed disabled:opacity-40 focus:outline-none`;
